import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TitleBar"] */ "/app/packages/desktop/lib/TitleBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudioProvider"] */ "/app/packages/meet-core/lib/AudioProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/meet-core/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
